import { DatasetHelmet } from "@/components/DatasetHelmet";
import { DatasetVersion } from "@/components/DatasetVersion";
import { invariant } from "@/utils/helpers";
import { graphql, Environment } from "react-relay";
import { LoaderArgs } from "@/utils/route";
import { DatasetOverviewPageQuery as DatasetOverviewPageQueryType } from "./__generated__/DatasetOverviewPageQuery.graphql";
import { preload, usePreloaded } from "@/utils/relay";
export default function DatasetOverviewPage() {
  const {
    query: { datasetBySlug: dataset },
  } = useDatasetOverviewPageQuery();
  invariant(!!dataset);
  return (
    <DatasetHelmet dataset={dataset}>
      <DatasetVersion datasetVersion={dataset.versions.nodes[0]} />
    </DatasetHelmet>
  );
}
const DatasetOverviewPageQuery = graphql`
  query DatasetOverviewPageQuery($owner: String!, $slug: String!) {
    datasetBySlug(owner: $owner, localSlug: $slug) {
      viewerCanUpdate: viewerCan(action: UPDATE_DATASET)
      versions(first: 1) {
        nodes {
          viewerCanUpdate: viewerCan(action: UPDATE_DATASET_VERSION)
          ...DatasetVersionFragment
          ...DatasetVersionEditSheet
        }
      }
      ...DatasetHelmetFragment
    }
  }
`;
export const loader = (environment: Environment) => {
  return ({ params: { owner, slug } }: LoaderArgs) => {
    if (!owner || !slug) {
      throw new Response("No owner or slug", { status: 500 });
    }
    return preload<DatasetOverviewPageQueryType>(
      environment,
      DatasetOverviewPageQuery,
      {
        owner,
        slug,
      },
    );
  };
};
const useDatasetOverviewPageQuery = () =>
  usePreloaded<DatasetOverviewPageQueryType>();
